import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeView from '../views/HomeView.vue'
import VueMeta from 'vue-meta'
import i18n from '@/i18n.js'
import store from '../store'
import { api } from '@/plugins/axios.js'
// import axios from 'axios'
import swal from 'sweetalert2'
Vue.use(VueMeta)
Vue.use(VueRouter)

const routes = [
  {
    // 首頁
    path: '/',
    name: 'HomeView',
    component: HomeView,
    meta: {
      title: '明日之星旅行社'
    }
  },
  {
    // 首頁(帶有推薦碼)
    path: '/referrer/:token',
    name: 'Referrer',
    component: HomeView
  },
  // {
  //   path: '/signup',
  //   name: 'signup',
  //   component: HomeView,
  //   meta: {
  //     title: '明日之星旅行社'
  //   }
  // },
  {
    // 外文首頁
    path: '/lang/:lang',
    name: 'HomeForeign',
    component: () => import(/* webpackChunkName: "HomeForeign" */ '../views/HomeForeign.vue')
  },
  {
    // 關於我們
    path: '/about/:lang',
    name: 'AboutAndWhy2',
    component: () => import(/* webpackChunkName: "AboutAndWhy2" */ '../views/AboutAndWhy.vue')
  },
  {
    // 關於我們
    path: '/about',
    name: 'AboutAndWhy',
    component: () => import(/* webpackChunkName: "AboutAndWhy" */ '../views/AboutAndWhy.vue')
  },
  {
    // 國外高爾夫版單
    path: '/outbound-golf',
    name: 'OutboundGolf',
    component: () => import(/* webpackChunkName: "OutboundGolf" */ '../views/OutboundGolf.vue')
  },
  {
    // 國外高爾夫版單 有推薦碼
    path: '/outbound-golf/ref/:token',
    name: 'OutboundGolfRef',
    component: () => import(/* webpackChunkName: "OutboundGolf" */ '../views/OutboundGolf.vue')
  },
  {
    // 查看球場
    path: '/golf/:area',
    name: 'GolfCourt',
    component: () => import(/* webpackChunkName: "golfcourt" */ '../views/GolfCourt.vue')
  },
  {
    // 查看旅館
    path: '/hotel/:area',
    name: 'HotelPage',
    component: () => import(/* webpackChunkName: "HotelPage" */ '../views/HotelPage.vue')
  },
  {
    // 搜尋旅遊團(帶推薦碼)
    path: '/search/:id/ref/:token',
    name: 'SearchPageRef',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchPage.vue')
  },
  {
    // 搜尋旅遊團
    path: '/search/:id',
    name: 'SearchPage',
    component: () => import(/* webpackChunkName: "search" */ '../views/SearchPage.vue')
  },
  // 管理員登入
  {
    path: '/login',
    name: 'LoginPage',
    component: () => import(/* webpackChunkName: "login" */ '../views/LoginPage.vue')
  },
  {
    // 旅遊團詳細頁(帶推薦碼)
    path: '/tour/:id/ref/:ref_code',
    name: 'TourPageRef',
    component: () => import(/* webpackChunkName: "TourPageRef" */ '../views/TourPage.vue')
  },
  {
    // 旅遊團詳細頁
    path: '/tour/:id',
    name: 'TourPage',
    component: () => import(/* webpackChunkName: "tour" */ '../views/TourPage.vue')
  },
  {
    // 舊結帳待刪
    path: '/checkout/:id',
    name: 'CheckOut',
    component: () => import(/* webpackChunkName: "checkout" */ '../views/CheckOut.vue')
  },
  // 舊結帳待刪
  {
    path: '/jpcheckout',
    name: 'JPCheckOut',
    component: () => import(/* webpackChunkName: "jpcheckout" */ '../views/JPCheckOut.vue')
  },
  // 忘記密碼
  {
    path: '/forgot',
    name: 'Forgot',
    component: () => import(/* webpackChunkName: "forgot" */ '../views/ForgotPage.vue')
  },
  {
    path: '/forgot/member',
    name: 'ForgotMember',
    component: () => import(/* webpackChunkName: "ForgotMember" */ '../views/ForgotPage.vue')
  },
  // 重設密碼
  {
    path: '/setpassword/:token',
    name: 'setPSW',
    component: () => import(/* webpackChunkName: "setPSW" */ '../views/ForgotPage.vue')
  },
  // 國內旅費計算
  {
    path: '/price',
    name: 'PriceCalculation',
    component: () => import(/* webpackChunkName: "PriceCalculation" */ '../views/PriceCalculation.vue')
  },
  // 此頁為用在iframe的，所以要隱藏navbar、footer
  {
    path: '/price-calculation',
    name: 'PriceCalculationIframe',
    component: () => import(/* webpackChunkName: "PriceCalculationIframe" */ '../views/PriceCalculation.vue'),
    meta: {
      hideNavFooter: true
    }
  },
  // 國外旅費計算
  {
    path: '/price-outbound',
    name: 'PriceCalculationOutbound',
    component: () => import(/* webpackChunkName: "PriceCalculationOutbound" */ '../views/PriceCalculationOutbound.vue')
  },
  {
    path: '/email-verify/:token',
    name: 'EmailVerify',
    component: () => import(/* webpackChunkName: "EmailVerify" */ '../views/EmailVerify.vue')
  },
  // 旅遊契約
  {
    path: '/contract',
    name: 'ContractPage',
    component: () => import(/* webpackChunkName: "ContractPage" */ '../views/ContractPage.vue')
  },
  // OP要求的簽證頁
  {
    path: '/visa',
    name: 'VisaPage',
    component: () => import(/* webpackChunkName: "VisaPage" */ '../views/VisaPage.vue')
  },
  {
    path: '/visa/:id',
    name: 'VisaDetailPage',
    component: () => import(/* webpackChunkName: "VisaDetailPage" */ '../views/VisaDetailPage.vue')
  },

  // 管理後台
  {
    path: '/admin',
    name: 'Admin',
    component: () => import(/* webpackChunkName: "admin" */ '../views/AdminPage.vue'),
    children: [
      // 明日3 - 首頁旅遊團分類
      {
        path: 'tourssort',
        name: 'AdminToursSort',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminToursSort.vue')
      },
      // 明日3 - 旅遊團
      {
        path: 'tours',
        name: 'AdminTours',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminTours.vue')
      },
      // 明日3 - 旅遊團分類
      {
        path: 'category',
        name: 'AdminCategory',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminCategory.vue')
      },
      // 明日3 - 景點
      {
        path: 'spots',
        name: 'AdminSpot',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminSpot.vue')
      },
      {
        path: 'spots/:id',
        name: 'AdminSpotId',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminSpotId.vue')
      },
      // 明日3 - 球場
      {
        path: 'golf',
        name: 'Golf',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGolf.vue')
      },
      {
        path: 'tour-orders',
        name: 'AdminOrdersOld',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminOrdersOld.vue')
      },
      // 明日3 - 注意事項
      {
        path: 'other',
        name: 'AdminOther',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminOther.vue')
      },
      // 明日3 - 旅館
      {
        path: 'hotels',
        name: 'AdminHotel',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminHotel.vue')
      },
      // 明日3 - 管理員
      {
        path: 'admin',
        name: 'AdminAdmin',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminAdmin.vue'),
        meta: {
          admin: true
        }
      },
      // 明日2 - SEO
      {
        path: 'seo2',
        name: 'AdminSeo2',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminSeo2.vue')
      },
      // 明日3 - SEO
      {
        path: 'seo3',
        name: 'AdminSeo3',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminSeo3.vue')
      },
      // 明日3 - 車
      {
        path: 'car',
        name: 'AdminCar',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminCar.vue')
      },
      // 明日2 - 航班
      {
        path: 'flight',
        name: 'AdminFlight',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminFlight.vue')
      },
      // 訂單 - 明日詢問
      {
        path: 'inquiry',
        name: 'Inquiry',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminInquiry.vue')
      },
      // 訂單 - 東成
      {
        path: 'geaw_orders',
        name: 'AdminGeawOrders',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGeawOrders.vue')
      },
      // 東成 - 會員
      {
        path: 'geaw_member',
        name: 'AdminGeawMember',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGeawMember.vue')
      },
      // 東成 - 商品審核
      {
        path: 'geaw_product',
        name: 'AdminGeawProducts',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGeawProducts.vue')
      },
      // 東成 - 產品分類
      {
        path: 'geaw_category',
        name: 'AdminGeawCategory',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGeawCategory.vue')
      },
      // 東成 - 設定傭金(配合廠商的)
      {
        path: 'geaw_set_reward',
        name: 'AdminGeawSetReward',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGeawSetReward.vue')
      },
      // 東成 - 分潤獎金
      {
        path: 'reward',
        name: 'AdminReward',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminReward.vue')
      },
      // 東成西就 - 各會員註冊連結
      {
        path: 'geaw_register_url',
        name: 'AdminGeawRegisterUrl',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminGeawRegisterUrl.vue')
      },
      // 明日3 - Inbound 旅費成本設定
      {
        path: 'in_price',
        name: 'AdminInPrice',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminInPrice.vue')
      },
      // 明日3 - Outbound 旅費成本設定
      {
        path: 'out_price',
        name: 'AdminOutPrice',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminOutPrice.vue')
      },
      // 明日3 - Outbound 成本細項
      {
        path: 'out_settings',
        name: 'AdminOutSettings',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminOutSettings.vue')
      },
      // 東成西就 - 內部商品分潤設定
      {
        path: 'product_group',
        name: 'AdminProductGroup',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminProductGroup.vue')
      },
      // 明日3 - 會員
      {
        path: 'member',
        name: 'AdminMember',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminMember.vue')
      },
      // 明日3 - 管理簽證
      {
        path: 'visa',
        name: 'AdminVisa',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminVisa.vue')
      },
      // 明日3 - 地區分類
      {
        path: 'area',
        name: 'AdminArea',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminArea.vue')
      },
      // 明日3 - 版單(報價單)
      {
        path: 'quotation',
        name: 'AdminQuotation',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminQuotation.vue')
      },
      // 明日3 - 代理(管理代理帳號)
      {
        path: 'agent',
        name: 'AdminAgent',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminAgent.vue')
      },
      // 明日3 - 餐廳
      {
        path: 'meal',
        name: 'AdminMeal',
        component: () => import(/* webpackChunkName: "admin" */ '../views/AdminMeal.vue')
      },
      // 網站說明
      {
        path: 'website_tutorial',
        name: 'WebsiteTutorial',
        component: () => import(/* webpackChunkName: "admin" */ '../views/WebsiteTutorial.vue')
      }
    ]
  },

  // 代理後台
  {
    path: '/agent',
    name: 'Agent',
    component: () => import(/* webpackChunkName: "agent" */ '../views/AgentPage.vue'),
    children: [
      {
        path: 'spots',
        name: 'AgentSpot',
        component: () => import(/* webpackChunkName: "agent" */ '../views/AgentSpot.vue'),
        meta: {
          agent: true
        }
      },
      {
        path: 'hotels',
        name: 'AgentHotel',
        component: () => import(/* webpackChunkName: "agent" */ '../views/AgentHotel.vue'),
        meta: {
          agent: true
        }
      },
      {
        path: 'golf',
        name: 'AgentGolf',
        component: () => import(/* webpackChunkName: "agent" */ '../views/AgentGolf.vue'),
        meta: {
          agent: true
        }
      },
      {
        path: 'car',
        name: 'AgentCar',
        component: () => import(/* webpackChunkName: "agent" */ '../views/AgentCar.vue'),
        meta: {
          agent: true
        }
      },
      {
        path: 'in_price',
        name: 'AgentInPrice',
        component: () => import(/* webpackChunkName: "agent" */ '../views/AgentInPrice.vue'),
        meta: {
          agent: true
        }
      },
      {
        path: 'out_price',
        name: 'AgentOutPrice',
        component: () => import(/* webpackChunkName: "agent" */ '../views/AgentOutPrice.vue'),
        meta: {
          agent: true
        }
      },
      {
        path: 'out_settings',
        name: 'AgentOutSettings',
        component: () => import(/* webpackChunkName: "agent" */ '../views/AgentOutSettings.vue'),
        meta: {
          agent: true
        }
      }
    ]
  },
  {
    path: '/notfound',
    name: 'NotFound',
    component: () => import(/* webpackChunkName: "NotFound" */ '../views/NotFound.vue')
  },
  {
    path: '*',
    redirect: '/'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: '/tours',
  routes
})

// 路由守衛
router.beforeEach(async (to, from, next) => {
  // console.log(to)
  // 預設所有頁面都是中文
  i18n.locale = 'tw'

  if (to.path.startsWith('/admin') || to.path.startsWith('/agent')) {
    if (!store.state.jwt) {
      swal.fire({
        icon: 'warning',
        text: '無權限',
        timer: 1000
      })
      return next('/')
    }

    const { data } = await api.get('php_modules2/user.php?type=jwt', {
      headers: { authorization: store.state.jwt }
    })
    // console.log(data)
    if (data.success) {
      // 如果要進管理員頁但不是admin，則回首頁
      if (to.meta.admin && store.state.group !== 'admin') {
        return next('/')
      }
      // 代理後台允許管理員跟代理進入
      if (to.meta.agent && store.state.group !== 'agent' && store.state.group !== 'admin') {
        return next('/')
      }
      next() // 其餘則成功跳頁
    } else {
      // JWT逾時或錯誤，登出
      store.commit('logout', '/login')
    }
  }
  // PriceCalculation 旅費試算頁 檢查登入狀態
  if (to.name === 'PriceCalculation' && store.getters.loginRole === 'staff') {
    const { data } = await api.get('php_modules2/user.php?type=jwt', {
      headers: { authorization: store.state.jwt }
    })
    if (!data.success) {
      store.state.jwt = ''
    }
  }

  // console.log(to)
  // 只有在首頁及外文首頁，navbar才顯示語言切換
  store.state.showLang = to.name === 'HomeForeign' || to.path === '/'
  if (to.path === '/') {
    localStorage.setItem('locale', '')
    i18n.locale = 'tw'
  }

  next()
})

export default router
